import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { catchError, map } from 'rxjs';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { User } from './model/entity-model';

@Injectable()
export class AuthService {
    static config = {
        client_id: 'genesisTrailersClient',
        accessName: 'access_token',
        refreshName: 'refresh_token',
    };

    private userSubject: BehaviorSubject<User>;
    public get currentUser(): User {
        return this.userSubject.value;
    }

    additionalUser: any;
    additionalUserTimestamp: Date;
    private refreshTokenTimeout: any;

    constructor(private http: HttpClient, private router: Router) {
        this.userSubject = new BehaviorSubject<User>(null);
    }

    login(username: string, password: string) {
        return this.http.post<any>(`${environment.serviceName}/users/authenticate`, { username, password }, { withCredentials: true }).pipe(
            map((user) => {
                this.setUser(user);
            })
        );
    }

    logout() {
        this.http.post<any>(`${environment.serviceName}/users/revoke-token`, {}, { withCredentials: true }).subscribe();
        this.stopRefreshTokenTimer();
        this.userSubject.next(null);
        this.router.navigate(['/login']);
    }

    private setUser(user: any) {
        this.userSubject.next(user);
        this.startRefreshTokenTimer();
        return user;
    }

    private startRefreshTokenTimer() {
        // parse json object from base64 encoded jwt token
        // if (this.currentUser) {

            const jwtToken = JSON.parse(atob(this.currentUser?.jwtToken.split('.')[1]));

            // set a timeout to refresh the token every fifteen minutes
            const timeout = 10 * 60 * 1000;
            this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
        // }
    }

    refreshToken() {
        return this.http.post<any>(`${environment.serviceName}/users/refresh-token`, {}, { withCredentials: true }).pipe(
            map((user) => {
                return this.setUser(user);
            }),
            // catchError((error) => {
            //     console.log('pipe failed');
            //     this.startRefreshTokenTimer();
            //     return this.userSubject;
            // })
        );
    }

    private stopRefreshTokenTimer() {
        clearTimeout(this.refreshTokenTimeout);
    }

    hasRole(role: string) {
        const current = this.userHasRole(this.currentUser, role);
        // if (moment(this.additionalUserTimestamp).add(1, 'minutes') < moment(new Date())) {
        //     this.additionalUser = null;
        //     this.additionalUserTimestamp = null;
        // }
        // const additional = this.userHasRole(this.additionalUser, role);
        return current; // || additional;
    }

    userHasRole(user, role: string) {
        if (!user || !user.roles) return false;

        return user.roles.some((roleName: string) => {
            // see if user perm stsarts with perm to check
            return roleName.lastIndexOf(role, 0) === 0;
        });
    }
}
